import auth from '../../../services/auth'
import * as _ from 'lodash'
import messageDialog from '../../../components/message-dialog.vue'
import account from '../../../services/account'

export default {
  data() {
    return {
      user: auth.currentUser,
      address: undefined,
      errorCep: undefined,
      loadingAddress: Promise.resolve(true),
      addressIdTemp:undefined
    }
  },
  computed: {
  },
  mounted() {
    this.$forceUpdate();
    this.loadingAddress = account.getAddressMailing(this.user.moveMaisId).then((resp) => {
      
      this.address = resp;
      this.addressIdTemp = this.address.addressId;
    });

  },
  methods: {
    updateAddress() {
      return this.$validator.validateAll()
        .then((success) => {
          this.address.moveMaisId = this.user.moveMaisId;
          if (success)
            return account.updateAddress(this.address).then((response)=>{
            //   if(response.data.status.code == 0){
            //      messageDialog.show({ title: 'Sucesso', message: response.data.status.message });
            //   }
            // }).catch((err) => {
            //   messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
            });
        });
    },
    queryAddress() {
      this.errorCep = undefined;
      this.loadingAddress = account.queryAddress(this.address.zipCode)
        .then((resp) => {
        
        this.address = resp;
         this.address.type = 'MAILING';
         this.address.addressId = this.addressIdTemp;
          this.$nextTick(function () {
            this.$validator.validateAll();
          });
        })
        .catch((err) => {
          this.errorCep = err.data.status.message;
          this.$validator.validateAll();
        });
    },
    queryAddressTyping(){
      if(this.address.zipCode.length < 8)
        return;
      this.queryAddress();
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/account/profile/address.js